import { PeopleBrandDto } from "./people-brand.dto";
import { PeopleCostCentreDto } from "./people-cost-centre.dto";
import { PeopleMerchantGroupDto } from "./people-merchant-group.dto";
import { PeopleRosterDto } from "./people-roster.dto";
import { PeopleEmployeeClockInOutDto } from "./employee/people-employee-clock-in-out.dto";
import { PeopleEmployeeDto } from "./employee/people-employee.dto";
import { PeopleQueryBaseDto } from "./people-query-base.dto";

export class PeopleMerchantDto {
    id: number;
    name: string;
    costCentreId: number;
    merchantGroupId: number;
    brandId?: number;

    rosters?: PeopleRosterDto[];
    merchantGroup?: PeopleMerchantGroupDto;
    costCentre?: PeopleCostCentreDto;
    brand?: PeopleBrandDto;
    clockInOut?: PeopleEmployeeClockInOutDto;
    employees?: PeopleEmployeeDto[];
}

export interface PeopleMerchantQueryDto extends PeopleQueryBaseDto {
    merchantGroupId?: number;
    name?: string;
}